<template>
    <div v-bind:class="sponsorclass">
        <div v-for="sponsorItem in sponsor" :key="sponsorItem.ID" v-if="sponsorItem.sponsorlogo" class="sponsorItem">
            <a v-bind:href="sponsorItem.sponsorlink" target="_blank">
                <img v-bind:src="sponsorItem.sponsorlogo">
            </a>
        </div>
    </div>
</template>


<script>


    export default {
        name: 'sponsorenebene',
        components: {

        },
        data() {
            return {

            }
        },

        props: {
            sponsor: {
                type: Object,
                default: () => {
                }
            }
        },
        computed: {
            sponsorclass() {
                switch (this.sponsor.ebene) {
                    case '1':
                        return 'sponsor-patron'
                    case '2':
                        return 'sponsor-main'
                    case '3':
                        return 'sponsor-premium'
                    case '4':
                        return 'sponsor-partner'
                    default:
                        return 'sponsor-partner'
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .sponsor-patron{
        text-align: center;
        background: #FFF;
        padding: 10px;
        .sponsorItem{
            display: inline-block;
            vertical-align: middle;
            width: 20%;
            @screen md {
                max-width: 180px;
            }
            padding: 2.3%;
            img{
                border: 3px solid #FFF;
            }
        }
    }
    .sponsor-main{
        text-align: center;
        background: #FFD700;
        padding: 10px;
        .sponsorItem{
            display: inline-block;
            vertical-align: middle;
            width: 45%;
            @screen md {
                max-width: 300px;
            }
            padding: 2.3%;
            img{
                border: 3px solid #FFF;
            }
        }

    }
    .sponsor-premium{
        text-align: center;
        background: #F0E68C;
        padding: 10px;
        .sponsorItem{
            display: inline-block;
            vertical-align: middle;
            width: 30%;
            @screen md {
                max-width: 250px;
            }
            padding: 2.3% 1.5%;
            img{
                border: 3px solid #FFF;
            }
        }
    }
    .sponsor-partner{
        text-align: center;
        background: #FAFAD2;
        padding: 10px;
        .sponsorItem{
            display: inline-block;
            vertical-align: middle;
            width: 22%;
            @screen md {
                max-width: 200px;
            }
            padding: 2.3% 1.5%;
            img{
                border: 3px solid #FFF;
            }
        }
    }
</style>
